import React, { useState } from 'react';
import { ArrowUpRight, Plus, Minus } from 'lucide-react';
import { services } from '../../data/mock';
import LogoWatermark from './LogoWatermark';

const Services = () => {
  const [openId, setOpenId] = useState(services[0].id);
  const active = services.find((s) => s.id === openId) || services[0];

  return (
    <section id="services" className="section relative overflow-hidden" style={{ background: '#12367F', color: '#FFFFFF' }}>
      <LogoWatermark size={620} opacity={0.06} position="right" />
      <div className="container-x relative">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
          <span className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-white/70">
            Our Services
          </span>
        </div>
        <h2
          className="font-display uppercase text-balance max-w-5xl"
          style={{ fontSize: 'clamp(2.25rem, 5.5vw, 5rem)', lineHeight: 0.92 }}
        >
          The <span style={{ color: '#2EF5FF' }}>full stack</span> of social-first services your brand needs to grow.
        </h2>

        <div className="mt-14 md:mt-20 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden bg-white/5">
              <img
                key={active.id}
                src={active.image}
                alt={active.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <span className="font-display uppercase text-3xl md:text-5xl text-white drop-shadow">
                  {active.title}
                </span>
              </div>
            </div>
          </div>

          {/* Accordion */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="divide-y divide-white/10 border-y border-white/10">
              {services.map((s) => {
                const isOpen = s.id === openId;
                return (
                  <div key={s.id} className="py-2">
                    <button
                      onClick={() => setOpenId(isOpen ? null : s.id)}
                      className="w-full flex items-center justify-between text-left py-5 group"
                    >
                      <span
                        className={`font-display uppercase transition-colors ${
                          isOpen ? 'text-[#2EF5FF]' : 'text-white group-hover:text-[#2EF5FF]'
                        }`}
                        style={{ fontSize: 'clamp(1.6rem, 3.5vw, 3rem)' }}
                      >
                        {s.title}
                      </span>
                      <span
                        className={`shrink-0 h-10 w-10 md:h-12 md:w-12 rounded-full grid place-items-center transition-colors ${
                          isOpen ? 'bg-[#2EF5FF] text-[#12367F]' : 'bg-white/10 text-white group-hover:bg-white/20'
                        }`}
                      >
                        {isOpen ? <Minus className="h-5 w-5" /> : <Plus className="h-5 w-5" />}
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-2xl">
                          {s.body}
                        </p>
                        <a
                          href="/contact"
                          className="mt-5 inline-flex items-center gap-2 text-[#2EF5FF] hover:translate-x-1 transition-transform"
                        >
                          Learn more <ArrowUpRight className="h-4 w-4" />
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
